import addressApis from "../../api/address";
import storeApis from "../../api/stores";

const defaultState = {
    address1: [],
    address2: [],
    address3: [],
    stores: []
}

const state = {...defaultState};

const getters = {};

const mutations = {
    RESET: (state) => {
      state = {...defaultState};
    },
    SET_ADDRESS3: (state, value) => {
        state.address3 = value;
    },
    SET_ADDRESS2: (state, value) => {
        state.address2 = value;
    },
    SET_ADDRESS1: (state, value) => {
        state.address1 = value;
    },
    SET_STORES: (state, value) => {
        state.stores = value;
    },
};

const actions = {
    async getAddress3({commit}, query) {
        const {data} = await addressApis.getAllAddress3(query);
        await commit("SET_ADDRESS3", data.data);
    },

    async getAddress2({commit}, query) {
        const {data} = await addressApis.getAllAddress2(query);
        await commit("SET_ADDRESS2", data.data);
    },

    async getAddress1({commit}, query) {
        const {data} = await addressApis.getAllAddress1(query);
        await commit("SET_ADDRESS1", data.data);
    },

    async getStores({commit}, query) {
        const {data} = await storeApis.getStores(query);
        await commit("SET_STORES", data.data);
    }
};

export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};